module.exports = __webpack_public_path__ + "media/images/photo/Commercial/slider3-dc804f28eec7832e01ec50abce17018b.png";